import { MtProject } from "server/models"
import { LangType } from "client/store"
import * as Const from "client/components/pdfmake/template/const"


const TitlePage = (
    project: MtProject,
    lang: LangType,
) => [
    {
        image: "accountLogo",
        fit: [450, 160],
        alignment: "center",
        margin: [0, 30, 0, 0],
    },
    {
        text: lang.ccReviewComplianceReport,
        style: Const.TITLE,
        margin: [0, 80, 0, 0],
    },
    {
        text: project.name,
        style: Const.SUB_TITLE,
        margin: [0, 10, 0, 25],
    },
    {
        image: "projectLogo",
        fit: [120, 120],
        alignment: "center",
    },
] as any[]
export default TitlePage
